// Talks to the Kamakhya backend. Reading the catalog needs no auth (it's
// public); submitting a form (sample request, bulk quote, distributor
// application, contact, order) also needs no admin key — that's only for
// the CMS's product-editing operations, not for customers using the
// storefront's own forms.
// Where the API lives. Read (in order) from:
//   1. public/config.js  -> window.__APP_CONFIG__.API_BASE_URL  (edit on the server, no rebuild)
//   2. REACT_APP_API_BASE_URL at build time
//   3. http://localhost:8000 for local development
const runtimeApiUrl = (typeof window !== "undefined" && window.__APP_CONFIG__ && window.__APP_CONFIG__.API_BASE_URL) || "";
const BASE_URL = (runtimeApiUrl || process.env.REACT_APP_API_BASE_URL || "http://localhost:8000").replace(/\/$/, "");

class ApiError extends Error {
  constructor(message, status) {
    super(message);
    this.status = status;
  }
}

async function request(path, { method = "GET", body } = {}) {
  let res;
  try {
    res = await fetch(`${BASE_URL}${path}`, {
      method,
      headers: body ? { "Content-Type": "application/json" } : undefined,
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch {
    throw new ApiError(`Could not reach the API at ${BASE_URL}.`, 0);
  }

  const text = await res.text();
  const data = text ? JSON.parse(text) : null;

  if (!res.ok) {
    throw new ApiError(data?.message || `Request failed (${res.status})`, res.status);
  }
  return data;
}

export const api = {
  // Pulls the full catalog in one page — the storefront's own filter/sort/
  // pagination UI runs client-side over this list, same as it did with the
  // old static data file.
  listAllProducts: () => request(`/products?limit=1000`),
  getProduct: (id) => request(`/products/${id}`),

  // Every storefront form (sample request, bulk quote, distributor
  // application, contact, order) submits through this single endpoint,
  // differentiated by `type`. See backend/src/models/Submission.js.
  createSubmission: (data) => request(`/submissions`, { method: "POST", body: data }),

  // Customer feedback the CMS has approved for the public site. Read-only and
  // deliberately narrow: name, rating and message only — never contact details.
  listPublishedFeedback: () => request(`/submissions/feedback`),
};

export { ApiError, BASE_URL };
